
<template>
    
        <mars-view :style="{
        display: auto
            ? 'inline-block'
            : '',
        padding: type === 'primary'
            ? (height - fontSize - 10)/2 + 'px 9px'
            : (height - fontSize - 10)/2 - 1 + 'px 8px',
        color: type === 'primary'
            ? '#fff'
            : primaryColor === '#555'
                ? '#000'
                : primaryColor,
        border: type !== 'primary' && !shadow
            ? '1px solid ' + primaryColor
            : '',
        backgroundColor: type === 'primary'
            ? primaryColor
            : touchActive
                ? 'rgba(0,0,0,.08)'
                : '#fff',
        opacity: touchActive && type === 'primary'
            ? 0.9
            : disabled
                ? 0.4
                : 1,
        background: background
            ? background
            : {},
        fontSize: fontSize + 'px',
        lineHeight: fontSize + 10 + 'px',
        borderRadius,
        fontWeight
    }" :class="{
        'shadow': shadow
    }" class="btn c-font-normal" @touchstart.native="handleTouchStart" @touchend.native="handleTouchEnd"><slot></slot></mars-view>
    
</template>

<script>
export default {
  props: {
    /**
     * 按钮类型；'primary' 主按钮；'default' 默认按钮
     */
    type: {
      type: String,
      default: 'default'
    },

    /**
     * 主颜色
     */
    primaryColor: {
      type: String,
      default: '#555'
    },

    /**
     * 背景
     */
    background: {
      type: String
    },

    /**
     * 是否自适应
     */
    auto: {
      type: Boolean,
      default: false
    },

    /**
     * 圆角弧度
     */
    borderRadius: {
      type: String,
      default: '5px'
    },

    /**
     * 阴影 box-shadow: 0 3px 9px 0 rgba(0,0,0,0.08);
     */
    shadow: {
      type: Boolean,
      default: false
    },

    /**
     * 字号大小
     */
    fontSize: {
      type: Number,
      default: 14
    },

    /**
     * 字号粗细
     */
    fontWeight: {
      type: String
    },

    /**
     * 按钮高度
     */
    height: {
      type: Number,
      default: 38
    },

    /**
     * 是否禁用
     */
    disabled: {
      type: Boolean,
      default: false
    }
  },

  data() {
    return {
      touchActive: false
    };
  },

  methods: {
    handleTouchStart(e) {
      if (this.disabled) {
        return;
      }

      this.touchActive = true;
    },

    handleTouchEnd(e) {
      if (this.disabled) {
        return;
      }

      this.touchActive = false;
    }

  }
};
</script>

<style scoped>
.btn {
  text-align: center;
  -webkit-box-sizing: border-box;
          box-sizing: border-box;
  -webkit-transition: all 0.1s cubic-bezier(0.18, 0, 0.26, 1);
  transition: all 0.1s cubic-bezier(0.18, 0, 0.26, 1);
  -webkit-touch-callout: none;
  -webkit-user-select: none;
  -moz-user-select: none;
   -ms-user-select: none;
       user-select: none;
}
.shadow {
  -webkit-box-shadow: 0 1px 3px 0 rgba(0, 0, 0, 0.08);
          box-shadow: 0 1px 3px 0 rgba(0, 0, 0, 0.08);
}

</style>
